import React from 'react';
import { Avatar } from 'antd';
import { useSelector } from 'react-redux';
import './members.css';
import MyHeader from '../Header/Header.module.css';
import './MembersDropdown.css';

const MembersDropdown = ({ bare = false }) => {
  const document = useSelector((state) => state.editor.documentInformation);
  const user = useSelector((state) => state.editor.userInformation);
  const members = (document?.members || []).filter(m => m.id !== user?.userId);

  return (
    <div className={bare ? MyHeader.memberPreviewBare : `memberDropdownWrapper ${MyHeader.memberDropdownContent}`}>
      {members.map((m) => (
        <div className="member-dropdown-item" key={m.id}>
          <Avatar src={m.image} size={18} style={{ backgroundColor: m.image ? 'transparent' : undefined }}>
            {!m.image && m.name ? m.name.charAt(0).toUpperCase() : null}
          </Avatar>
          <div className="member-name-role">
            <div className="member-name">{m.name}</div>
            <div className="member-role">{m.role || m.designation || m.title || ''}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MembersDropdown;